export default __webpack_public_path__ + "static/styles-dropdown-legacy-84ce94f57f120fb98e59138b946cac980ff34b9e745b4bedb1c40dfdd79fafeb.png";